import React from "react";

import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";

import { FormikAwareBusinessPICSelector } from "components/Form/FormikControls/BusinessPICSelector";
import { withNamespace } from "components/Form/FormikControls/lib";
import { Row } from "components/Layout";

import { BUYER, TRANSPORTER, VENDOR } from "constants/businesses";

import { MobileTransactionalCreateSaleFormValues } from "components/MobileTransactionalModal/lib/types";

interface WhoTabProps {
  saleLotNamespace: string;
  consignmentNamespace: string;
}

export const WhoTab = ({
  saleLotNamespace,
  consignmentNamespace,
}: WhoTabProps) => {
  const { values } =
    useFormikContext<MobileTransactionalCreateSaleFormValues>();

  const isBuyerRequired = !!(values.saleLots ?? []).some(
    lot => !!Number(lot.unitPrice),
  );

  return (
    <Grid item container xs={12}>
      <Row fullWidth marginVertical={2}>
        <FormikAwareBusinessPICSelector
          label="Vendor"
          subLabel="Search by Business Name or PIC"
          businessFieldName={withNamespace(consignmentNamespace, "vendor_id")}
          propertyFieldName={withNamespace(
            consignmentNamespace,
            "vendor_property_id",
          )}
          businessRoles={[VENDOR]}
          labelFontSize="charlie"
          subLabelFontSize="beta"
        />
      </Row>

      <Row fullWidth marginVertical={2}>
        <FormikAwareBusinessPICSelector
          label="Buyer"
          subLabel="Search by Business Name or PIC"
          businessFieldName={withNamespace(saleLotNamespace, "buyer_id")}
          propertyFieldName={withNamespace(
            saleLotNamespace,
            "destination_property_id",
          )}
          businessRoles={[BUYER]}
          optional={!isBuyerRequired}
          labelFontSize="charlie"
          subLabelFontSize="beta"
        />
      </Row>

      <Row fullWidth marginVertical={2}>
        <FormikAwareBusinessPICSelector
          label="Carrier"
          subLabel="Search by Business Name"
          businessFieldName={withNamespace(
            consignmentNamespace,
            "carrierCharge.carrier",
          )}
          businessRoles={[TRANSPORTER]}
          allowBusinessOnly
          labelFontSize="charlie"
          subLabelFontSize="beta"
        />
      </Row>
    </Grid>
  );
};
